{
  "male": [
    "Thorin",
    "Dain",
    "Gromli",
    "Bofur",
    "Durgan",
    "Balin",
    "Thrain",
    "Eitri",
    "Adrik",
    "Alberich",
    "Baern",
    "Barendd",
    "Brottor",
    "Bruenor",
    "Dorn",
    "Eberk",
    "Einkil",
    "Fargrim",
    "Adalgrim",
    "Gardain",
    "Harbek",
    "Kildrak",
    "Morgran",
    "Orsik",
    "Oskar",
    "Rangrim",
    "Rurik",
    "Taklinn",
    "Thoradin",
    "Tordek",
    "Traubon",
    "Travok",
    "Ulfgar",
    "Veit",
    "Vondal",
    "Bombur",
    "Dwalin",
    "Gloin",
    "Oin",
    "Nain",
    "Fundin",
    "Groin",
    "Thror",
    "Frerin",
    "Borin",
    "Farin",
    "Floi",
    "Loni",
    "Narvi",
    "Telchar",
    "Azaghal",
    "Brokk",
    "Sindri",
    "Durin",
    "Andvari",
    "Regin",
    "Alfrik",
    "Berling",
    "Dvalinn",
    "Grerr",
    "Hreidmar",
    "Fafnir",
    "Austri",
    "Vestri",
    "Nordri",
    "Sudri",
    "Mimir",
    "Thjazi",
    "Bifur",
    "Nori",
    "Dori",
    "Ori",
    "Frar",
    "Gimrik",
    "Hlodvar",
    "Kolgrim",
    "Magnar",
    "Ottar",
    "Ragnvald",
    "Sigvard",
    "Thorvald",
    "Bomrik",
    "Vragnar",
    "Yngvar",
    "Dulgar",
    "Bjarki",
    "Brandr",
    "Dagr",
    "Eldgrim",
    "Fjalar",
    "Galar",
    "Hjalmar",
    "Ingvi",
    "Jarngrim",
    "Kettil",
    "Lofar",
    "Mjolnar",
    "Nyrad",
    "Orri",
    "Svafr",
    "Throst",
    "Torvin",
    "Ulfrik",
    "Vigdur",
    "Yrsan",
    "Burlok",
    "Thurik",
    "Grundi",
    "Hurgan",
    "Korrin",
    "Durrim",
    "Brannoc",
    "Durnik",
    "Gorund",
    "Haldric",
    "Khazrim",
    "Kragnar",
    "Murdin",
    "Norrak",
    "Ruddur",
    "Stoggar",
    "Tharkun",
    "Ungrim",
    "Vorrik",
    "Zorund",
    "Bardin",
    "Bergar",
    "Dolgrim",
    "Drummond",
    "Fornar",
    "Fengar",
    "Garrund",
    "Grimbold",
    "Hargin",
    "Jorund",
    "Kazador",
    "Gimdor",
    "Logrim",
    "Morek",
    "Nardur",
    "Olfgar",
    "Snorri",
    "Thargrim",
    "Ufrik",
    "Volkar",
    "Ansgar",
    "Bramir",
    "Calder",
    "Dagnir",
    "Dorrin",
    "Eskil",
    "Fornjot",
    "Gadrin",
    "Grundar",
    "Halvar",
    "Harthak",
    "Hrolf",
    "Isgar",
    "Jorvik",
    "Grorin",
    "Kharn",
    "Krom",
    "Lothar",
    "Mardok",
    "Narn",
    "Odgrim",
    "Rognar",
    "Skorri",
    "Storri",
    "Hjorrik",
    "Thogar",
    "Ulmar",
    "Varn",
    "Wulfar",
    "Yorrik",
    "Belgrim",
    "Bodvar",
    "Brom",
    "Dargo",
    "Edrin",
    "Fendrel",
    "Gunnar",
    "Hamund",
    "Hedin",
    "Holgar",
    "Ivar",
    "Jalgrim",
    "Kazbor",
    "Kolbein",
    "Lodvar",
    "Malgrim",
    "Nimrik",
    "Olvar",
    "Prandor",
    "Rodric",
    "Sigurd",
    "Stenmar",
    "Tormund",
    "Ullar",
    "Vallin",
    "Weland",
    "Abbarn",
    "Baldrak",
    "Brundar",
    "Dellin",
    "Khorlin",
    "Fendur",
    "Gilbrand",
    "Grimnir",
    "Hagrin",
    "Hodrik",
    "Jarnulf",
    "Lorgrim",
    "Kuldar",
    "Mathrik",
    "Mozgrim",
    "Nordak",
    "Oddvar",
    "Paldar",
    "Rhunar",
    "Saldrin",
    "Skaldir",
    "Tobrin",
    "Mornak",
    "Vandrik",
    "Yorund",
    "Zarrak",
    "Arngrim",
    "Bersi",
    "Brokkar",
    "Dorgar",
    "Narvik",
    "Falgrim",
    "Gorm",
    "Grettir",
    "Hallbjorn",
    "Haukr",
    "Hundur",
    "Kjartan",
    "Kolli",
    "Leiknir",
    "Njal",
    "Onund",
    "Orrund",
    "Snorrin",
    "Starkad",
    "Thorgest",
    "Thrand",
    "Torgil",
    "Ulfhedin",
    "Vermund",
    "Aldrun",
    "Bazrim",
    "Belmor",
    "Dumgrim",
    "Elgar",
    "Gimbrun",
    "Grundl",
    "Hamdir",
    "Jorek",
    "Kurvin",
    "Mazrak",
    "Nolgrim",
    "Ogrund",
    "Raggan",
    "Stromm",
    "Thadrik",
    "Tungur",
    "Vigrim",
    "Wolgar",
    "Zabor",
    "Brakki",
    "Dagmar",
    "Dvorn",
    "Fili",
    "Fror",
    "Gamil",
    "Grimm",
    "Hornbori",
    "Kili",
    "Mjodvitnir",
    "Rakkor",
    "Rumnir",
    "Sturl",
    "Thekk",
    "Uldrin",
    "Valgar",
    "Zirak",
    "Borgar",
    "Garmund",
    "Durlach",
    "Hrothgar",
    "Keldorn",
    "Morthal",
    "Barrak",
    "Kord",
    "Skardin",
    "Bror",
    "Ragnor",
    "Thakgrim"
  ],
  "female": [
    "Brunhild",
    "Helga",
    "Aldra",
    "Sigrun",
    "Kildra",
    "Vala",
    "Amber",
    "Artin",
    "Audhild",
    "Bardryn",
    "Dagna",
    "Diesa",
    "Eldeth",
    "Falkrunn",
    "Finellen",
    "Gunnloda",
    "Gurdis",
    "Hlin",
    "Kathra",
    "Sanna",
    "Ilde",
    "Liftrasa",
    "Berga",
    "Riswynn",
    "Herva",
    "Torbera",
    "Torgga",
    "Vistra",
    "Dis",
    "Hilde",
    "Astrid",
    "Unna",
    "Bardhild",
    "Eydis",
    "Frigga",
    "Gudrun",
    "Gunnhild",
    "Gerda",
    "Ingrid",
    "Jorunn",
    "Kolfinna",
    "Ragnhild",
    "Sigrid",
    "Solveig",
    "Svanhild",
    "Thora",
    "Thordis",
    "Thorhild",
    "Ljotta",
    "Valdis",
    "Bergra",
    "Aslaug",
    "Borghild",
    "Hallveig",
    "Ingunn",
    "Jodis",
    "Ketilrid",
    "Ranveig",
    "Rannveig",
    "Sigyn",
    "Thurid",
    "Alfdis",
    "Asdis",
    "Brynja",
    "Eira",
    "Freydis",
    "Thruda",
    "Halla",
    "Hjordis",
    "Idunn",
    "Jofrid",
    "Valda",
    "Oddny",
    "Rundra",
    "Sefa",
    "Tova",
    "Ulfrun",
    "Vigdis",
    "Arnora",
    "Bera",
    "Dalla",
    "Embla",
    "Mjolla",
    "Hekja",
    "Kadlin",
    "Lofna",
    "Magna",
    "Nanna",
    "Dagnhild",
    "Rota",
    "Skadi",
    "Snotra",
    "Steina",
    "Yngvild",
    "Agna",
    "Barra",
    "Bruna",
    "Dorga",
    "Dunna",
    "Dorthild",
    "Eldrun",
    "Garda",
    "Grunhild",
    "Hadda",
    "Hedra",
    "Irna",
    "Jarna",
    "Kelda",
    "Frodis",
    "Lodda",
    "Morra",
    "Norra",
    "Odda",
    "Rurna",
    "Sindra",
    "Storra",
    "Tharra",
    "Ulla",
    "Gerdra",
    "Grundis",
    "Amra",
    "Berda",
    "Brigga",
    "Darra",
    "Durna",
    "Eldra",
    "Frida",
    "Helgra",
    "Hildrun",
    "Jorrun",
    "Isrun",
    "Kaja",
    "Ketta",
    "Maeva",
    "Nerra",
    "Ondra",
    "Rikka",
    "Kolrun",
    "Thelda",
    "Torra",
    "Urda",
    "Valka",
    "Magnild",
    "Ysgra",
    "Adda",
    "Bekka",
    "Norrun",
    "Daina",
    "Elka",
    "Odrun",
    "Gerta",
    "Grisla",
    "Hanna",
    "Rangrid",
    "Jorna",
    "Karla",
    "Kilda",
    "Mardra",
    "Nalda",
    "Sigdra",
    "Stenhild",
    "Rilda",
    "Thordra",
    "Talla",
    "Ulfdis",
    "Velda",
    "Yrna",
    "Agda",
    "Bodil",
    "Branna",
    "Disa",
    "Ebba",
    "Fritha",
    "Gisla",
    "Gydja",
    "Hrafna",
    "Inga",
    "Jutta",
    "Kolla",
    "Lilja",
    "Marta",
    "Vandra",
    "Olga",
    "Randa",
    "Signy",
    "Tilda",
    "Yngrun",
    "Vigga",
    "Asa",
    "Bersa",
    "Dagrun",
    "Dyrna",
    "Erna",
    "Gerdrun",
    "Gunna",
    "Herdis",
    "Holma",
    "Iverna",
    "Jora",
    "Kirsta",
    "Malka",
    "Nolda",
    "Ofna",
    "Rana",
    "Selda",
    "Thrana",
    "Ulfa",
    "Vesna",
    "Wilda",
    "Arnhild",
    "Belra",
    "Dagmara",
    "Druda",
    "Elsbet",
    "Grimhild",
    "Haldra",
    "Hjalma",
    "Ketilda",
    "Kolbrun",
    "Liva",
    "Magnhild",
    "Dvalrun",
    "Runa",
    "Isra",
    "Tordis",
    "Ulvhild",
    "Rosga",
    "Brenhild",
    "Gudny",
    "Hnossa",
    "Hrunda",
    "Jarnsaxa",
    "Ingvelda",
    "Ranna",
    "Gjafa",
    "Freyda",
    "Bergdis",
    "Fjola",
    "Glumra",
    "Hrodny",
    "Ingibjorg",
    "Ingrida",
    "Hilma",
    "Sváva",
    "Torunn",
    "Aldis",
    "Bardis",
    "Deldra",
    "Eskja",
    "Gudla",
    "Heidrun",
    "Svana",
    "Katla",
    "Landra",
    "Mordis",
    "Rolla",
    "Sveina",
    "Torvi",
    "Vedis",
    "Amalda",
    "Falka",
    "Gunnra",
    "Dagda",
    "Elda",
    "Folka",
    "Gretta",
    "Hroswitha",
    "Irdra",
    "Kragga",
    "Marga",
    "Notta",
    "Dorna",
    "Skerra",
    "Thurna",
    "Vonna",
    "Bryndis",
    "Hafdis",
    "Saldis",
    "Ulfhild",
    "Gersemi",
    "Hedda",
    "Thorgunn",
    "Arnbjorg",
    "Idda",
    "Ingirid",
    "Ragnfrid",
    "Lyngra",
    "Bjorga",
    "Dalgra",
    "Thryn",
    "Haldis",
    "Embrun",
    "Gunnara",
    "Aldgisa",
    "Hargra",
    "Dunhild",
    "Fjalla",
    "Gudrid",
    "Malda",
    "Nolla"
  ],
  "family": [
    "Ironfist",
    "Stonebeard",
    "Deepdelver",
    "Anvilborn",
    "Coppervein",
    "Hammerfall",
    "Granitebrow",
    "Forgeheart",
    "Goldseam",
    "Blackanvil",
    "Balderk",
    "Battlehammer",
    "Brawnanvil",
    "Dankil",
    "Fireforge",
    "Frostbeard",
    "Gorunn",
    "Holderhek",
    "Loderr",
    "Lutgehr",
    "Rumnaheim",
    "Strakeln",
    "Ungart",
    "Axebiter",
    "Bronzehelm",
    "Cragborn",
    "Deepforge",
    "Dunbarrow",
    "Emberhold",
    "Flintmantle",
    "Goldvein",
    "Graniteheart",
    "Hearthstone",
    "Ironhelm",
    "Kegbreaker",
    "Lodestone",
    "Mithrilmane",
    "Oakshield",
    "Orebreaker",
    "Quarrystone",
    "Runeforge",
    "Silverpick",
    "Steelbeard",
    "Stonehand",
    "Thunderhelm",
    "Truehammer",
    "Underhill",
    "Wyrmsbane",
    "Ashbeard",
    "Battleborn",
    "Blackrock",
    "Bloodaxe",
    "Boulderback",
    "Brightvein",
    "Bronzebeard",
    "Cavemaul",
    "Chiselhand",
    "Coalbrow",
    "Copperhelm",
    "Cragmantle",
    "Deepmantle",
    "Diamondeye",
    "Dragonbane",
    "Dunforge",
    "Earthsong",
    "Embervein",
    "Fellhammer",
    "Firebeard",
    "Flintbeard",
    "Forgefire",
    "Frostforge",
    "Gemcutter",
    "Gildedhelm",
    "Goldbeard",
    "Graniteshield",
    "Gravelbeard",
    "Greyforge",
    "Grimhammer",
    "Hammerhand",
    "Hardstone",
    "Helmcleaver",
    "Hillsplitter",
    "Ironbrow",
    "Ironhide",
    "Ironvein",
    "Jewelhand",
    "Keystone",
    "Leadfoot",
    "Lodehammer",
    "Longbeard",
    "Marblehelm",
    "Mattockhand",
    "Mountainheart",
    "Nickelbrow",
    "Oathstone",
    "Orevein",
    "Quartzbeard",
    "Redbeard",
    "Rockjaw",
    "Rubyhelm",
    "Runeshield",
    "Shalebrow",
    "Shieldbiter",
    "Silverbeard",
    "Slagforge",
    "Slatebeard",
    "Smeltborn",
    "Spiderbane",
    "Stoneshoulder",
    "Stonetooth",
    "Stoutale",
    "Strongarm",
    "Tinbeard",
    "Torchbearer",
    "Trollbane",
    "Tunnelborn",
    "Underdeep",
    "Veinseeker",
    "Whitebeard",
    "Wyrmforge",
    "Anvilhand",
    "Axeheart",
    "Barrelchest",
    "Beardgrip",
    "Bellowsmith",
    "Blackbeard",
    "Bladehelm",
    "Bouldershield",
    "Brassbrow",
    "Brewmaster",
    "Bristlebeard",
    "Cinderbeard",
    "Coalheart",
    "Copperkettle",
    "Cragfist",
    "Deeprock",
    "Delvesong",
    "Dourbrow",
    "Dustbeard",
    "Earthshaker",
    "Emberforge",
    "Feldspar",
    "Fireheart",
    "Flamebeard",
    "Forgeborn",
    "Frosthelm",
    "Gemhand",
    "Gildbeard",
    "Goblinbane",
    "Goldhand",
    "Granitejaw",
    "Gravelheart",
    "Greystone",
    "Gritbeard",
    "Hammerstone",
    "Hearthguard",
    "Helmforge",
    "Hornblower",
    "Ironbeard",
    "Irongut",
    "Ironshoulder",
    "Kegsmith",
    "Lanternjaw",
    "Lavabrow",
    "Mithrilhand",
    "Mossbeard",
    "Mountainborn",
    "Mudbeard",
    "Obsidian",
    "Onyxhelm",
    "Orefist",
    "Pebblefoot",
    "Pitborn",
    "Quarryhand",
    "Rivetbeard",
    "Rockbeard",
    "Rubyheart",
    "Runebeard",
    "Shaftsinger",
    "Shieldwall",
    "Silverforge",
    "Slatehelm",
    "Smeltfire",
    "Soottongue",
    "Steelfist",
    "Stoneborn",
    "Stonecutter",
    "Stonefoot",
    "Stoneheart",
    "Stoutheart",
    "Thanehold",
    "Thunderbeard",
    "Torchfist",
    "Trollhammer",
    "Tunnelfist",
    "Veinstrike",
    "Warbeard",
    "Anvilsong",
    "Axebeard",
    "Bellowborn",
    "Bitterbeard",
    "Blackstone",
    "Boulderfist",
    "Brasshelm",
    "Brightaxe",
    "Brightforge",
    "Broadbeam",
    "Bronzefist",
    "Cairnstone",
    "Caskbreaker",
    "Chiselbeard",
    "Cinderhelm",
    "Coalfist",
    "Copperfist",
    "Cragbeard",
    "Deepaxe",
    "Deepstone",
    "Diamondfist",
    "Dragonforge",
    "Duskforge",
    "Eagleaxe",
    "Earthbeard",
    "Embershield",
    "Fernbeard",
    "Flintfist",
    "Forgehammer",
    "Frostfist",
    "Gemstone",
    "Gildforge",
    "Goldaxe",
    "Goldforge",
    "Graniteaxe",
    "Greyhelm",
    "Grimstone",
    "Hammerbeard",
    "Hardhelm",
    "Helmbreaker",
    "Ironaxe",
    "Ironforge",
    "Ironhammer",
    "Jadehelm",
    "Keldaxe",
    "Lodefist",
    "Marblefist",
    "Mithrilaxe",
    "Nightforge",
    "Oakenshield",
    "Oreheart",
    "Pickheart",
    "Quartzhelm",
    "Redaxe",
    "Rockfist",
    "Runeaxe",
    "Saltbeard",
    "Shalefist",
    "Silveraxe",
    "Slagbeard",
    "Steelhelm",
    "Stoneaxe",
    "Stonehelm",
    "Thunderaxe",
    "Tinhelm",
    "Trollfist",
    "Underforge",
    "Wyrmaxe",
    "Kazakar",
    "Durrakal",
    "Khazbar",
    "Morgunn",
    "Belgrimm",
    "Brundsson",
    "Dagnirsson",
    "Eitridottir",
    "Holgarsson",
    "Thraindottir",
    "Grundsson",
    "Haldorsson",
    "Vigdisdottir",
    "Ironsdottir",
    "Aldrakhar",
    "Barazhul",
    "Belzunn",
    "Dunnagol",
    "Feldrunn",
    "Karak-Varn",
    "Khazrak",
    "Mordahl",
    "Norrgrim",
    "Rhudaur",
    "Thorbardin",
    "Tharbad",
    "Uzbarak",
    "Brokkhall",
    "Durnholt",
    "Eldkeep",
    "Grimmholm",
    "Haldenvar",
    "Kragmoor",
    "Lodestar",
    "Mithral",
    "Orzammar",
    "Ravenholm",
    "Skarrfell",
    "Stonehollow",
    "Thrumgard",
    "Vostgard",
    "Zarrakul",
    "Bannerbeard",
    "Barrelhoop",
    "Bellowsbreath",
    "Blastbeard",
    "Boulderborn",
    "Braidbeard",
    "Brickhand",
    "Cairnwarden",
    "Candlebeard",
    "Cobblefoot",
    "Deepwarden",
    "Dunmantle",
    "Fathomdeep",
    "Fellforge",
    "Flagonfist",
    "Forgewarden",
    "Furnaceborn",
    "Gearbeard",
    "Glimmervein",
    "Gloomdelver",
    "Gravelfoot",
    "Greathelm",
    "Hammerfist",
    "Hearthforge",
    "Hollowdelve",
    "Ingotmaker",
    "Ironbound",
    "Ironwarden",
    "Kilnheart",
    "Lampwright",
    "Lanternbrow",
    "Lodewarden",
    "Mallethand",
    "Oreborn",
    "Pewterbeard",
    "Pickwright",
    "Quenchsteel",
    "Rimehelm",
    "Rivetfist",
    "Rubyvein",
    "Runecarver",
    "Rustbeard",
    "Seamfinder",
    "Shaftwarden",
    "Shieldborn",
    "Silvervein",
    "Slatefist",
    "Smithson",
    "Soothammer",
    "Spadebeard",
    "Stalwart",
    "Steelvein",
    "Stonedelver",
    "Stonewarden",
    "Tankardhand",
    "Tongsmith",
    "Torchwarden",
    "Tunnelwarden",
    "Undervein",
    "Vaultborn",
    "Vaultkeeper",
    "Wedgehammer",
    "Wellforge",
    "Whetstone",
    "Ashforge",
    "Basaltborn",
    "Brazenhelm",
    "Cobaltbeard",
    "Dolmenfist",
    "Emberdelve",
    "Garnethelm",
    "Glintaxe",
    "Hollowforge",
    "Jasperhand",
    "Leadbeard",
    "Magmaheart",
    "Marrowstone",
    "Opalbeard",
    "Pumicefoot",
    "Scoriaborn",
    "Skarnhelm",
    "Tallowbeard",
    "Tarnhelm",
    "Topazbeard",
    "Zinchand",
    "Gorundsson",
    "Kragnarsson",
    "Thuridottir",
    "Dagnydottir",
    "Barrowdeep",
    "Coalbiter",
    "Rockbiter",
    "Stonebiter",
    "Ironbiter",
    "Adamantbrow",
    "Alebarrel",
    "Anvilguard",
    "Ashenhelm",
    "Axemantle",
    "Beardbraid",
    "Bedrockborn",
    "Blackvein",
    "Bluestone",
    "Boldhammer",
    "Bouldergrip",
    "Brazierborn",
    "Breakstone",
    "Bronzeshield",
    "Burnishedhelm",
    "Caskbrow",
    "Cavernborn",
    "Cleftrock",
    "Coalvein",
    "Copperbraid",
    "Craghold",
    "Deepbraid",
    "Deepvein",
    "Dirgehammer",
    "Doomhelm",
    "Drakefist",
    "Drumstone",
    "Dunhammer",
    "Earthbound",
    "Emberbraid",
    "Fellstone",
    "Firehand",
    "Flinthelm",
    "Forgebrow",
    "Frostvein",
    "Gemborn",
    "Glowforge",
    "Goldbraid",
    "Graniteborn",
    "Greyvein",
    "Grimforge",
    "Hammerborn",
    "Hammersong",
    "Hearthbraid",
    "Highforge",
    "Hillborn",
    "Holdfast",
    "Ironbraid",
    "Ironsong",
    "Jadevein",
    "Kegbrow",
    "Lodeborn",
    "Marblebrow",
    "Mattockborn",
    "Mithrilvein",
    "Moltenhand",
    "Mountainjaw",
    "Nightvein",
    "Oakbeard",
    "Orebraid",
    "Pickbrow",
    "Quarryborn",
    "Ravenhelm",
    "Redforge",
    "Rockbraid",
    "Rubybraid",
    "Runebraid",
    "Runehammer",
    "Sandstone",
    "Shalebeard",
    "Shieldhammer",
    "Silverbraid",
    "Slatebraid",
    "Smelthand",
    "Steelbraid",
    "Stonebraid",
    "Stonesong",
    "Stoutbraid",
    "Thunderforge",
    "Tinforge",
    "Trollhelm",
    "Truebeard",
    "Truesteel",
    "Tunnelsong",
    "Underhelm",
    "Veinbraid",
    "Wardstone",
    "Wyrmhelm",
    "Ironmantle",
    "Gravelsong",
    "Dourhammer",
    "Bitterforge",
    "Coldhearth",
    "Lastanvil",
    "Firstforge",
    "Oldhammer",
    "Deepbrow",
    "Kettlebrow",
    "Darkdelve"
  ],
  "gendered": {
    "male": [
      "Brundsson",
      "Dagnirsson",
      "Holgarsson",
      "Grundsson",
      "Haldorsson",
      "Gorundsson",
      "Kragnarsson"
    ],
    "female": [
      "Eitridottir",
      "Thraindottir",
      "Vigdisdottir",
      "Ironsdottir",
      "Thuridottir",
      "Dagnydottir"
    ]
  }
}
